import { createFileRoute, Outlet } from '@tanstack/react-router';
import { UsersRound } from 'lucide-react';

export const Route = createFileRoute('/admin-console/user-access')({
    staticData: {
        permissions: ['admin_users:read', 'admin_support:read'],
        breadcrumb: {
            title: 'User access',
            inactive: true,
        },
        ui: {
            icon: UsersRound,
            title: 'User and access',
            menuDescription: 'Manage users and access controls',
        },
    },
    component: Outlet,
});
